import React, { useContext, useEffect } from "react";
import HaqtInput from "../../components/HaqtInput/HaqtInput";
import * as yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../../services/LoginServices";
import { userRole } from "../../services/LoginServices";// added for wosh
import { getSessionStorageItem } from "../../utils/sessionStorageUtils";// added for wosh
import "./loginPageStyles.scss";
import { AppContext } from "../../context/AppContextProvider";
import { notifyError } from "../../components/Toaster/Toaster";

import mailImg from "../../assests/img/mailImg.png";
import lockImg from "../../assests/img/lockImg.png";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(.{8,})$/;
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const validationSchema = yup.object({
  email: yup
    .string("Enter your ID")
    .matches(emailRegex, "Enter a valid email address")
    .required("Enter a valid Email Address"),
  password: yup
    .string()
    .required("Enter a valid Password"),
});

const LoginPage = () => {
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      loginHandler(values);
    },
  });

  const navigate = useNavigate();
  const { user, setUser } = useContext(AppContext);


  useEffect(() => {
    if (Object.keys(user).length > 0) {
     // console.log("Map displayed via useEffect");
      navigate("/admin/maps");
    }
  }, [user]);

  const loginHandler = async (values) => {
    try {
      const response = await loginRequest(values);
      if (response && response.data) {
        setUser(response.data);
        sessionStorage.setItem("haqt_userinfo", JSON.stringify(response.data));
       
        const userInfo = getSessionStorageItem("haqt_userinfo");
        const userEmail=userInfo.email;
        
        try {
          // Fetch role in a separate try-catch block
          const roleResponse = await userRole(userEmail);
         // console.log('Role response:', roleResponse.data);
         
          // Store role data if needed
          if (roleResponse && roleResponse.data) {
          //  console.log('Role response data:', roleResponse.data); // Debug log
            // Only store role data if it's in the expected format
            if (typeof roleResponse.data === 'object') {
           //   console.log('Role response data is object:', roleResponse.data); // Debug log
             // const testuserrole = roleResponse.data.role;
            //  console.log("testing userrole",testuserrole);
              sessionStorage.setItem("haqt_userrole", JSON.stringify(roleResponse.data));
              const userRoleInfo = getSessionStorageItem("haqt_userrole");
              const testuserrole=userRoleInfo.role;
           //   console.log("testing userrole",testuserrole);
             // sessionStorage.setItem('haqt_userrole', JSON.stringify(roleResponse.data));
             navigate("/admin/maps");
            }
          }
        } catch (roleError) {
          // Log role error but don't prevent navigation
          console.error('Error fetching role:', roleError);
        }
        
      }
    } catch (error) {
      notifyError(error);
    }
  };
        //added for wosh
        /*  
        const userInfo = getSessionStorageItem("haqt_userinfo");
        const userEmail=userInfo.email;
        
        try {
          // Fetch role in a separate try-catch block
          const roleResponse = await userRole(userEmail);
          console.log('Role response:', roleResponse.data);
         
          // Store role data if needed
          if (roleResponse && roleResponse.data) {
            console.log('Role response data:', roleResponse.data); // Debug log
            // Only store role data if it's in the expected format
            if (typeof roleResponse.data === 'object') {
              console.log('Role response data is object:', roleResponse.data); // Debug log
             // sessionStorage.setItem('haqt_userrole', JSON.stringify(roleResponse.data));
            }
          }
        } catch (roleError) {
          // Log role error but don't prevent navigation
          console.error('Error fetching role:', roleError);
        }
   
        navigate("/admin/maps");
        }
      // Check if response exists and has data
    /*
        if (roleResponse && roleResponse.data) {
          console.log('Role data received:', roleResponse.data);
        //  sessionStorage.setItem('haqt_userrole', JSON.stringify(roleResponse.data));
          navigate("/admin/maps");
        } else {
          console.log('No role data received');
        }
       
      } 
          catch (error) {
      notifyError(error);
      console.error('Login error:', error);
      // Handle error appropriately - maybe set a default role or show error message
    }
  };*/
   



  const handleFormSubmit = (event) => {
    event.preventDefault();
    if (!formik.values.email && !formik.values.password && !formik.errors) {
      notifyError("Both fields are required.");
    } else {
      formik.handleSubmit(event);
    }
  };


  return (
    <div className="login-page-container">
      <form onSubmit={handleFormSubmit} className="login-form">
        <div className="mb-2">
          <HaqtInput
            fullWidth
            id="email"
            name="email"
            className="focus-placeholder"
            placeholder="ID"
            type="text"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            icon={<img src={mailImg} height={16} width={20} />}
          />
        </div>
        <div className="mb-2">
          <HaqtInput
            fullWidth
            id="password"
            name="password"
            className="focus-placeholder"
            placeholder="Password"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            icon={<img src={lockImg} height={17} width={20} />}
          />
        </div>

        <div style={{ textAlign: "center", marginBottom: '14px' }} >
          <p
            className="forgot-password-link"
            onClick={() => navigate("/auth/forgotPassword")}
          >
            Forgot Password?
          </p>
        </div>

        <button type="submit" className="btn btn-primary mb-2 login-button">
          Log In
        </button>
        <button
          type="submit"
          className="btn btn-primary  signup-button"
          onClick={() => navigate("/auth/newuserregistration")}
        >
          Sign Up
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
